import React, { Component } from "react";
import { service, actions } from "./data";
import { injectIntl, IntlShape } from "@ai360/core/intl";
import { withCrud, withMasked } from "~/hocs";
import { DataTable } from "~/core";
import { FormattingHelpers } from "@ai360/core";
import { memoizeFormattedRecords } from "~/admin/utils";
import { messages } from "../../../i18n-messages";

interface IEquationLogProps {
    records?: Record<string, unknown>[];
    intl: IntlShape;
}

export class EquationLog_ extends Component<IEquationLogProps> {
    getFormattedRecords = memoizeFormattedRecords(FormattingHelpers.formatLogDetailText);
    render(): JSX.Element {
        return (
            <div>
                <DataTable
                    service={service}
                    isCheckbox={false}
                    showFilterInput={false}
                    messages={messages}
                    {...this.props}
                    records={this.getFormattedRecords(this.props.records)}
                />
            </div>
        );
    }
}
export const EquationLog = injectIntl(withMasked(withCrud(EquationLog_, service, actions)));
